module.exports = __webpack_public_path__ + "static/media/about-image.c2851ed9.png";